import { Component } from "@angular/core";
import { BaseModal } from "@app/shared/cerrix-modal/BaseModal";
import { DataStructureModel } from "@app/datamanagement/models/DataStructureModel";

@Component({
    selector: "archivepolicy-dialog",
    templateUrl: "./archivepolicy-dialog.component.html",
    styleUrls: ["./archivepolicy-dialog.component.scss", "../../../../sass/datamanagement.scss"],
    standalone: false
})
export class ArchivePolicyDialogComponent extends BaseModal {
    dataStructures: DataStructureModel[];
    disabled: boolean;

    // Base modal implementation
    okClick() {
        this._bsModalRef.hide();

        super.onConfirm(this.dataStructures);
    }

    closeClick() {
        super.onCancel();
    }
}
